import axios from '@/axiosConnection'
import toastr from '@/toastr'

export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
  },
  actions: {
    addItem(context, item) {
      let params = {
        api_url: 'product-log',
        namespace: 'product_log',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'product-log',
        namespace: 'product_log',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/product_log.js